import { useFilterStatusContext } from "./filter-status.context";

export function FilterStatus() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterStatusContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}